<template>
  <div v-if="show" class="fixed inset-0 bg-gray-900 bg-opacity-70 flex items-center justify-center p-4 z-50 transition-opacity duration-300">
    <div class="w-full max-w-md bg-gray-800 text-white rounded-lg p-5 flex flex-col gap-4 relative shadow-xl">
      <!-- Header and Close Button -->
      <div class="flex justify-between items-center">
        <h2 class="text-xl font-semibold text-indigo-300" style="font-family: 'Creepster', cursive;">ระบบเชื้อโรค</h2>
        <button @click="$emit('close')" class="text-gray-400 hover:text-indigo-300 transition-colors duration-200">
          <i class="fas fa-times text-lg"></i>
        </button>
      </div>

      <!-- Infection System Information -->
      <div class="bg-gray-700 rounded-md p-3 border border-gray-600">
        <p class="text-sm text-indigo-200 mb-2">
          ระดับเชื้อโรค จะเพิ่มขึ้นเมื่อตัวละครถูกซอมบี้โจมตีและไม่สามารถหลบได้ ซอมบี้แต่ละตัวมีโอกาสติดเชื้อ (<span class="text-yellow-400">infectionChance</span>) เช่น 10% ซึ่งอาจเพิ่มเชื้อโรค 1 หน่วยต่อการโจมตี
        </p>
        <p class="text-sm text-indigo-200 mb-2">
          คุณสามารถซื้อยาต้านเชื้อไวรัสได้ที่ร้านค้า
        </p>
        <p class="text-sm text-indigo-200">
          <span class="text-red-400 font-bold">คำเตือน:</span> หากระดับเชื้อโรคถึง <span class="text-yellow-400">100</span> ตัวละครจะ<span class="text-red-400">เสียชีวิต</span> และเข้าสู่เหตุการณ์เกิดใหม่ โดยจะสูญเสียไอเทม(เสีย 0-1), ทักษะ(เสีย 0), รอยสัก(เสีย 0-1) และห้องจำนวน(เสีย 0-1)
        </p>
      </div>

      <!-- Close Button -->
      <div class="flex justify-center">
        <button @click="$emit('close')" class="bg-indigo-600 hover:bg-indigo-700 text-sm text-white py-2 px-4 rounded-md transition-colors duration-200 flex items-center gap-2">
          <i class="fas fa-times text-xs"></i> ปิด
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfectionModal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close'],
};
</script>

<style scoped>
.animate-swing {
  animation: swing 1s infinite;
}

@keyframes swing {
  0% { transform: rotate(0deg); }
  25% { transform: rotate(15deg); }
  75% { transform: rotate(-15deg); }
  100% { transform: rotate(0deg); }
}

button:not(:disabled):active {
  transform: scale(0.98);
}
</style>